<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="M10.875 6.75a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0Z"/>
    <path fill-rule="evenodd" d="M3.75 6.75A5.246 5.246 0 0 1 9 1.5a5.246 5.246 0 0 1 5.25 5.25C14.25 10.688 9 16.5 9 16.5s-5.25-5.813-5.25-9.75ZM9 3C6.93 3 5.25 4.68 5.25 6.75c0 2.137 2.19 5.408 3.75 7.41 1.59-2.018 3.75-5.25 3.75-7.41C12.75 4.68 11.07 3 9 3Z" clip-rule="evenodd"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
